import { Model, Attr, HasMany, HasOne } from 'spraypaint';
import { FloraSurvey, User } from '@/api';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class FloraSurveyImport extends ApplicationRecord {
  static jsonapiType = 'flora-survey-imports';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Created',
        value: 'createdAt',
      },
    ];
  }

  static scopeFactory() {
    return FloraSurveyImport.includes([]);
  }

  // send to csv_import

  @Attr() createdAt: string;

  @Attr() success: boolean;

  @Attr() header: string[];

  @Attr() importErrors: CSVImportError[];

  @HasMany() createdFloraSurveys: FloraSurvey[];

  @HasOne() createdBy: User;
}
